import { useState } from 'react'
import AdminLayout from '../../layouts/AdminLayout'
import MatchEditor from '../../components/MatchEditor'
import { track } from '../../lib/events'

const FILTERS = [
  ['all', 'Todos'],
  ['todo', 'Por jogar'],
  ['live', 'A decorrer'],
  ['done', 'Terminados'],
]

function isPlayed(m) {
  return m.homeScore != null && m.awayScore != null
}

function matchState(m) {
  if (m.status === 'live') return 'live'
  if (m.status === 'finished' || isPlayed(m)) return 'done'
  return 'todo'
}

function passes(m, filter) {
  if (filter === 'all') return true
  return matchState(m) === filter
}

function StatusBadge({ m }) {
  const state = matchState(m)
  if (state === 'done') return <span className="st done">Final</span>
  if (state === 'live') return <span className="st live">Ao vivo</span>
  return <span className="st todo">Por jogar</span>
}

function matchTitle(m) {
  if (m.home && m.away) return `${m.home.shortName} vs ${m.away.shortName}`
  return m.label || `Jogo ${m.gameNumber}`
}

export default function Matches({ currentEdition, editions, matches = [] }) {
  const [filter, setFilter] = useState('all')
  const [selectedId, setSelectedId] = useState(matches[0]?.id ?? null)
  // On phones the editor opens as a bottom sheet; on desktop it is always
  // visible in the right column and this flag has no visual effect.
  const [sheetOpen, setSheetOpen] = useState(false)

  const visible = matches.filter((m) => passes(m, filter))
  const selected = matches.find((m) => m.id === selectedId) || visible[0] || null

  function pickFilter(key) {
    setFilter(key)
    track('admin-matches-filter-changed', { filter: key })
  }

  function pick(id) {
    setSelectedId(id)
    setSheetOpen(true)
  }

  return (
    <AdminLayout currentEdition={currentEdition} editions={editions} active="matches">
      <div className="adm-grid">
        <div>
          <div className="filters" style={{ marginBottom: '14px' }}>
            {FILTERS.map(([key, label]) => (
              <span
                key={key}
                className={`f ${filter === key ? 'on' : ''}`}
                onClick={() => pickFilter(key)}
              >
                {label}
              </span>
            ))}
          </div>
          <div className="adm-list">
            {visible.map((m) => (
              <div
                key={m.id}
                className={`adm-fx ${selected && selected.id === m.id ? 'sel' : ''}`}
                onClick={() => pick(m.id)}
              >
                <span className="gn">{m.gameNumber}</span>
                <span className="tm">
                  {matchTitle(m)}{' '}
                  <span style={{ color: 'var(--ink-soft)', fontWeight: 500 }}>
                    · {m.time}
                    {m.field ? ` · C${m.field}` : ''}
                  </span>
                </span>
                <span className="rr">
                  {isPlayed(m) ? `${m.homeScore}–${m.awayScore}` : '–'}
                </span>
                <StatusBadge m={m} />
              </div>
            ))}
          </div>
        </div>
        <div>
          {sheetOpen && <div className="editor-backdrop" onClick={() => setSheetOpen(false)} />}
          <div className={`editor-pane ${sheetOpen ? 'open' : ''}`}>
            <button type="button" className="editor-close" onClick={() => setSheetOpen(false)}>
              Fechar ✕
            </button>
            {selected ? (
              <MatchEditor
                match={selected}
                editionSlug={currentEdition.slug}
                onSaved={() => setSheetOpen(false)}
              />
            ) : (
              <div className="editor">
                <div className="et">Sem jogos</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
